const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Recordatorios y Mensajes Programados",
    summary:
      "Automatiza el envío de avisos, recordatorios y comunicaciones diferidas por WhatsApp. Programa la fecha y hora exacta para el despacho de mensajes a contactos específicos con reintentos inteligentes y control de estados.",
  },
  sections: [
    {
      id: "programacion_mensajes",
      title: "1. Programación de Envíos en Tiempo Futuro",
      description:
        "Configuración de fechas y destinatarios para alertas automáticas.",
      items: [
        {
          id: "destinatario_fecha",
          title: "Contacto y Fecha/Hora de Despacho",
          definition:
            "Selecciona el contacto receptor y define la fecha y minuto exacto en que BotMix despachará el mensaje por WhatsApp.",
        },
        {
          id: "contenido_personalizado",
          title: "Mensaje de Texto y Variables",
          definition:
            "Redacta el aviso con instrucciones, recordatorio de citas, vencimiento de pagos o confirmación de servicios.",
        },
      ],
    },
    {
      id: "estados_envio",
      title: "2. Monitoreo y Estados de Envío",
      description:
        "Trazabilidad de mensajes programados en el sistema.",
      items: [
        {
          id: "ciclo_estados",
          title: "Pendiente, Enviado o Fallido",
          definition:
            "Visualiza el estado de cada recordatorio. Si el mensaje aún está pendiente, puedes editarlo o cancelarlo antes de su ejecución.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Reminders & Scheduled WhatsApp Messages",
    summary:
      "Automate time-delayed notifications, payment reminders, and follow-up messages on WhatsApp. Schedule the exact date and hour for automated message delivery to targeted contacts with full delivery status tracking.",
  },
  sections: [
    {
      id: "programacion_mensajes",
      title: "1. Scheduling Future Outbound Messages",
      description:
        "Setting dates and recipients for automated reminders.",
      items: [
        {
          id: "destinatario_fecha",
          title: "Target Contact & Dispatch Timestamp",
          definition:
            "Select the recipient and specify the precise calendar date and minute when BotMix triggers the message through WhatsApp.",
        },
        {
          id: "contenido_personalizado",
          title: "Custom Message Copy & Notes",
          definition:
            "Compose instructions, appointment reminders, invoice due date alerts, or service check-ins.",
        },
      ],
    },
    {
      id: "estados_envio",
      title: "2. Dispatch Monitoring & Lifecycle",
      description:
        "Real-time tracking of scheduled communications.",
      items: [
        {
          id: "ciclo_estados",
          title: "Pending, Sent & Failed Statuses",
          definition:
            "Audit scheduled messages in real time. Pending dispatches can be updated or revoked anytime prior to dispatch execution.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Lembretes e Mensagens Agendadas",
    summary:
      "Automatize avisos, lembretes de consultas e cobranças no WhatsApp. Programe a data e o horário exato para o envio de mensagens a contatos específicos com rastreamento completo de entrega.",
  },
  sections: [
    {
      id: "programacion_mensajes",
      title: "1. Agendamento de Mensagens Futuras",
      description:
        "Definição de prazos e destinatários para notificações automáticas.",
      items: [
        {
          id: "destinatario_fecha",
          title: "Contato e Data/Hora do Envio",
          definition:
            "Escolha o contato que receberá a mensagem e defina o dia e minuto em que o BotMix fará o disparo automático pelo WhatsApp.",
        },
        {
          id: "contenido_personalizado",
          title: "Conteúdo da Notificação",
          definition:
            "Escreva mensagens de lembrete de consultas, avisos de vencimento ou acompanhamento pós-atendimento.",
        },
      ],
    },
    {
      id: "estados_envio",
      title: "2. Monitoramento e Status de Envio",
      description:
        "Acompanhamento da fila de disparos programados.",
      items: [
        {
          id: "ciclo_estados",
          title: "Pendente, Enviado ou Falhou",
          definition:
            "Verifique o andamento de cada lembrete. Mensagens pendentes podem ser editadas ou canceladas antes do horário de disparo.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Rappels et Messages Programmés",
    summary:
      "Automatisez l'envoi de notifications, rappels de rendez-vous et relances sur WhatsApp. Définissez la date et l'heure précises d'envoi pour chaque contact avec suivi en temps réel de l'état de distribution.",
  },
  sections: [
    {
      id: "programacion_mensajes",
      title: "1. Programmation des Envois Futurs",
      description:
        "Planification des dates et destinataires des alertes automatiques.",
      items: [
        {
          id: "destinatario_fecha",
          title: "Destinataire et Heure de Diffusion",
          definition:
            "Sélectionnez le contact et précisez la date et la minute exacte où BotMix transmettra le message via WhatsApp.",
        },
        {
          id: "contenido_personalizado",
          title: "Corps du Message et Personnalisation",
          definition:
            "Rédigez vos rappels de consultation, relances de paiement ou messages d'accompagnement.",
        },
      ],
    },
    {
      id: "estados_envio",
      title: "2. Suivi et Statuts de Traitement",
      description:
        "Traçabilité des messages mis en file d'attente.",
      items: [
        {
          id: "ciclo_estados",
          title: "En attente, Envoyé ou Échoué",
          definition:
            "Consultez l'historique d'envoi. Les messages programmés peuvent être modifiés ou annulés avant leur déclenchement.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "التذكيرات والرسائل المجدولة",
    summary:
      "أتمتة إرسال الإشعارات وتذكيرات المواعيد ورسائل المتابعة عبر واتساب. جدولة تاريخ ووقت الإرسال بدقة لجهات اتصال محددة مع متابعة حالات التسليم المباشرة.",
  },
  sections: [
    {
      id: "programacion_mensajes",
      title: "1. جدولة الرسائل التلقائية المستقبلية",
      description:
        "تحديد التواريخ وجهات الاتصال المستهدفة للتنبيهات الآلية.",
      items: [
        {
          id: "destinatario_fecha",
          title: "جهة الاتصال وتوقيت الإرسال",
          definition:
            "اختر العميل وحدد التاريخ والدقيقة المحددة التي سيقوم فيها BotMix بإرسال الرسالة تلقائياً عبر واتساب.",
        },
        {
          id: "contenido_personalizado",
          title: "نص التذكير والتعليمات",
          definition:
            "كتابة نصوص التذكير بالمواعيد، تنبيهات استحقاق الفواتير، أو رسائل المتابعة الدورية باحترافية.",
        },
      ],
    },
    {
      id: "estados_envio",
      title: "2. مراقبة حالات الإرسال والجدولة",
      description:
        "تتبع مسار الرسائل المبرمجة داخل النظام.",
      items: [
        {
          id: "ciclo_estados",
          title: "معلق، تم الإرسال، أو فشل",
          definition:
            "مراجعة حالة كل رسالة تذكير. يمكن تعديل الرسائل المعلقة أو إلغاؤها في أي وقت قبل حلول موعد إرسالها.",
        },
      ],
    },
  ],
};

export const SCHEDULES_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
